import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { secureFetch } from "./batchSecurity";

const getSessionData = () => ({
    userGuid: sessionStorage.getItem("SEC_USER_GUID")
});

const UTILITY_ENDPOINT = "/api/v1/sustina/utilities";

export const s3UtilityService = {

    /**
     * 📋 ACTION: Fetch Bucket Inventory
     */
    getInventory: async (bucketName, config, prefix = "") => {
        try {
            const { userGuid } = getSessionData();

            // 🎯 FIX: Flattened so main.py finds 'bucket' inside the first 'payload' level
            const requestBody = {
                action: "GET_INVENTORY",
                user_id: userGuid,
                payload: {
                    bucket: bucketName,
                    prefix: prefix
                }
            };

            const rawData = await secureFetch(
                UTILITY_ENDPOINT,
                "POST",
                config.siteKey,
                "Inventory",
                requestBody
            );

            const res = GoldenSourceHelper.normalize(rawData);
            if (!res.success) throw new Error(res.message || "Failed to fetch S3 inventory.");

            return res.getProp("files") || [];
        } catch (err) {
            console.error("S3 Inventory Fetch Error:", err);
            throw err;
        }
    },

    /**
     * 📥 ACTION: Download / Discovery Link
     */
    getDownloadUrl: async (bucketName, config, key) => {
        try {
            const { userGuid } = getSessionData();

            const requestBody = {
                action: "DOWNLOAD", // 🎯 Routes to presigned_download_service.py
                user_id: userGuid,
                payload: {
                    bucket: bucketName,
                    key: key
                }
            };

            const rawData = await secureFetch(
                UTILITY_ENDPOINT,
                "POST",
                config.siteKey,
                "Download",
                requestBody
            );

            return GoldenSourceHelper.normalize(rawData);
        } catch (err) {
            console.error("S3 Download URL Error:", err);
            throw err;
        }
    },

    /**
     * 🗑️ ACTION: Remove Object
     */
    removeObject: async (bucketName, config, key) => {
        try {
            const { userGuid } = getSessionData();

            const requestBody = {
                action: "REMOVE",
                user_id: userGuid,
                payload: {
                    bucket: bucketName,
                    key: key
                }
            };

            return await secureFetch(UTILITY_ENDPOINT, "POST", config.siteKey, "Remove", requestBody);
        } catch (err) {
            console.error("S3 Remove Object Error:", err);
            throw err;
        }
    },

    /**
     * 📝 ACTION: Rename Object
     */
    renameObject: async (bucketName, config, oldKey, newName) => {
        try {
            const { userGuid } = getSessionData();

            const requestBody = {
                action: "RENAME",
                user_id: userGuid,
                payload: {
                    bucket: bucketName,
                    old_key: oldKey,
                    new_key: newName
                }
            };

            return await secureFetch(UTILITY_ENDPOINT, "POST", config.siteKey, "Rename", requestBody);
        } catch (err) {
            console.error("S3 Rename Relay Failure:", err);
            throw err;
        }
    },

    /**
     * 🏷️ ACTION: Update Object Tags
     */
    updateTags: async (bucketName, config, key, tags) => {
        try {
            const { userGuid } = getSessionData();

            const requestBody = {
                action: "UPDATE_TAGS",
                user_id: userGuid,
                payload: {
                    bucket: bucketName,
                    key: key,
                    tags: tags 
                }
            };

            const rawData = await secureFetch(UTILITY_ENDPOINT, "POST", config.siteKey, "UpdateTags", requestBody);
            return GoldenSourceHelper.normalize(rawData);
        } catch (err) {
            console.error("S3 Tag Update Error:", err);
            throw err;
        }
    }
};